import { FileManagementContext } from "global/cnr/contexts/FileManagementContext";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { _allowUpload, useUpload } from "global/cnr/contexts/useHelpers/useUpload";
import { convertHelpers } from "global/common/convert";
import { dataModificationTypes } from "global/viewSettings/enums/itemActionTypes";
import { _longPressTypes } from "global/wrappers/LongPressWrapper";
import _ from 'lodash';
import React, { useContext, useMemo, useState } from "react";
import { Button, Icon } from 'semantic-ui-react';
import { DataModifyContext } from "../../cnr/contexts/DataModifyContext";
import { FrameworkContext } from "../../cnr/contexts/FrameworkContent";
import ItemStorageProvider from "../../cnr/contexts/ItemStorageContext";
import { ParentContext } from "../../cnr/contexts/ParentContext";
import { UiItemContext } from "../../cnr/contexts/UiItemContext";
import UploadProvider, { UploadContext } from "../../cnr/contexts/UploadContext";
import { frameworkLeftTypes } from "../../cnr/reducers/FrameworkReducer";
import UiSaveButtons from "../../components/buttons/UiSaveButtons";
import { appIconTypes } from "../../enums/appIconTypes";
import { gEnums } from '../../enums/globalEnums';
import { settingsIconTypes } from "../../enums/settingsIconTypes";
import GenericIcon from "../../genericControls/GenericIcon";
import { DataModificationsContext } from "../../pageItem/modification/UiDataModifications";
import { openExternal } from "../../viewSettings/helpers/settingsLinks";
import FullPageWrapper from "../../wrappers/FullPageWrapper";
import Wrapper, { wrapperTypes } from "../../wrappers/Wrapper";
import DropdownOptionsMenu from "../forms/elements/DropdownOptionsMenu";
import { DataManagementContext } from "../viewers/DataManagementViewer";
import BulkUploader from "./BulkUploader";
import SingleImageUploader from "./SingleImageUploader";

/**
 * This is a single item uploader with the select button that opens up a file directory
 * @param {*} props (storageLocationType, fileViewer_handlers, itemData: altItemData)
 * @returns BulkUploader OR SingleImageUploader
 */
const Uploader = (props) => {

  const {
    fileViewer_handlers,
    handleCancel,
    storageLocationType,
    useFull,
    fullMode,
    origin,
  } = props

  let { storageType } = props


  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states
  const { pathViews, lastView, lastViewKey } = paps_state

  const { aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection } = aps_appUserSettings ?? {}

  // authContext  
  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  // dataManagementContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { selectedDataMode, selectedCollectionKey, frInfo, fw_info, currentLongPress } = framework_state ?? {}
  const { longPressData } = currentLongPress ?? {}
  const { currentPageData, uivi } = frInfo ?? {}
  const { email } = currentPageData ?? {}
  const { handleShow_appDashboard } = framework_handlers ?? {}

  // dataManagementContext
  const dataModificationContext = useContext(DataModificationsContext)
  const { dataModifications_state } = dataModificationContext ?? {}
  const { dataModification, dataModificationType } = dataModifications_state ?? {}
  const { images } = dataModification ?? {}
  const { allow } = images ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const { dataManagement_state } = dataManagementContext ?? {}
  const { viewItem } = dataManagement_state ?? {}
  const { key: viewItemKey_dm } = viewItem ?? {}

  // dataModifyContext
  const dataModifyContext = useContext(DataModifyContext)
  const { dataModify_handlers } = dataModifyContext ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state } = uiItemContext ?? {}
  const { viewItem: viewItem_item, dataItem } = item_state ?? {}
  const { key: viewItemKey } = viewItem_item ?? {}

  // uploadContext
  const uploadContext = useContext(UploadContext);
  const { upload_state, upload_handlers } = uploadContext ?? {}

  // fileManagementContext
  const fileManagementContext = useContext(FileManagementContext)
  const { fileManagement_state } = fileManagementContext ?? {}
  const { fileManagmentOpts } = fileManagement_state ?? {}

  const _fileManagmentOpts = currentLongPress ? {
    viewItemType: currentLongPress.uivi,
    viewItemItem: currentLongPress.longPressData,
    fileOptionType: 'pages',
  } : fileManagmentOpts

  const { fileOptionType, storageType: storageType_fmo, viewItemType, viewItemItem } = _fileManagmentOpts ?? {}

  const { handleUpload_manual, handleUpload_profiles } = useUpload()

  let _storageType = storageType || storageType_fmo

  if (!_storageType) { _storageType = gEnums.storageTypes.image }
  const allowShowRefPath = allow || isAdminOrSuper

  let _noMid = false

  switch (origin) {
    case 'uiUpload':
      _noMid = false
      break;
    case 'manifestViewer':
      _noMid = true
      break;
    default:
    // nothing
  }

  let _viewItemKey = viewItemKey_dm ? viewItemKey_dm : viewItemKey
  if (props.viewItemKey) { _viewItemKey = props.viewItemKey }
  if (selectedCollectionKey) { _viewItemKey = selectedCollectionKey }

  const viewUploadProps = { view: lastView, viewKey: lastViewKey }
  if (storageLocationType === gEnums.storageLocationTypes.profiles) { viewUploadProps.imageUrlOnly = true }

  const { appImage, showBulkUploader, allFiles, useDarkMode, storageRef, storageLocationType: storageLocationType_us, avatarEditor, files_info, manifestFiles, updating, imageImage, confirmation } = upload_state ?? {}

  const _appImage = props?.appImage || appImage
  let _fileOptionType = fileOptionType

  const { selectedFolderFiles } = files_info ?? {}
  const { image_type, image_name, image_path, image_data } = _appImage ?? {}
  const dataName = image_data && convertHelpers.getItemName(image_data)

  let _storageLocationType = storageLocationType_us !== storageLocationType ? storageLocationType_us : storageLocationType

  if (image_type) {
    _storageLocationType = image_type
  }

  if (appUserCollection === _viewItemKey) {
    _storageLocationType = gEnums.storageLocationTypes.clientProfile
    _fileOptionType = gEnums.fileOptionTypes.clientProfile
    _fileManagmentOpts.fileOptionType = _fileOptionType
  }

  // returns the uploadPath!!! this is critical
  const { uploadPath, uploadCaption, fot } = useMemo(() => {

    let basePath = `clients/${pathViews.clients}/events/${pathViews.events}`

    let subPath = _storageLocationType
    let subPathAbr = _storageLocationType

    if (_fileManagmentOpts) {
      switch (_fileOptionType) {
        case gEnums.fileOptionTypes.global:
          subPath = `${_fileOptionType}/${_storageType}`
          subPathAbr = `${_fileOptionType}.${_storageType}`
          break;
        case gEnums.fileOptionTypes.pages:
          subPath = `${_fileOptionType}/${viewItemType}/${viewItemItem?._itemKey}`
          subPathAbr = `${_fileOptionType}.${viewItemType}.${viewItemItem?._itemKey}`
          break;
      }
    } else if (fw_info) {
      switch (_storageLocationType) {
        case gEnums.storageLocationTypes.clientProfile:
          basePath = `clients/${pathViews.clients}`;
          subPath = `profiles/${image_name}` || `${_appImage?.image_path}`;
          subPathAbr = `profiles/${image_name}` || `${_appImage?.image_path}`;
          _fileOptionType = gEnums.fileOptionTypes.clientProfile;
          break;
        default:
          subPathAbr = `pages.${fw_info?.uivi}.${fw_info?.viewKey}`
      }
    }

    if (currentLongPress) {
      switch (_storageLocationType) {
        case gEnums.storageLocationTypes.clientProfile:
          basePath = `clients/${pathViews.clients}`;
          subPath = `profiles/${longPressData?.email}`;
          subPathAbr = longPressData?.name || `${longPressData?.firstName} ${longPressData?.lastName}`
          break;
        default:
          subPath = `pages/${currentLongPress.uivi}/${currentLongPress.uiviKey}`;
          subPathAbr = longPressData?.name || `${longPressData?.firstName} ${longPressData?.lastName}`
      }

    }

    const _uploadPath = `${basePath}/${subPath}`
    const _uploadCaption = `...${subPath}`
    return { uploadPath: _uploadPath.replaceAll(), uploadCaption: _uploadCaption, fot: _fileOptionType }
  }, [])

  const captions = useMemo(() => {

    let _dataModificationType = dataModificationType

    if (currentLongPress?.longPressType === _longPressTypes.bannerImage) {
      _dataModificationType = dataModificationTypes.images
    }

    let _topper2 = image_path || image_name || dataName

    switch (_dataModificationType) {
      case dataModificationTypes.images:

        let _uivi = uivi
        let _uiviKey = fw_info?.viewKey
        if (fw_info?.uivi === appUserCollection || currentLongPress?.uivi === appUserCollection) {
          _uivi = appUserCollection
          _uiviKey = currentLongPress?.uiviKey
          _storageLocationType = gEnums.storageLocationTypes.clientProfile
          _topper2 = _topper2
        } else {
          switch (currentLongPress.longPressType) {
            case _longPressTypes.bannerImage:
              _storageLocationType = gEnums.storageLocationTypes.event
              break;
            default:

          }
        }


        switch (_storageLocationType) {
          case gEnums.storageLocationTypes.clientProfile:

          default:

        }
        return {
          topper: 'Upload Image',
          topper2: _topper2,
          ubc: `Upload Image >>`,
        }

      case dataModificationTypes.pdfs:
        return {
          topper: 'Upload PDF',
          topper2: `${_.startCase(_storageLocationType)}/${fw_info?.uivi}/${fw_info?.viewKey}`,
          ubc: `Upload PDF`,
        }

      default:
        return {
          topper: 'Upload Image',
          topper2: `${_.startCase(_storageLocationType)}/${fw_info?.uivi}/${fw_info?.viewKey}`,
          ubc: `Upload Image`,
        }
    }
  }, [])


  const inverted = _storageLocationType === gEnums.storageLocationTypes.event ? true : false

  let _selectedFiles;

  if (manifestFiles && manifestFiles.length > 0) {
    _selectedFiles = manifestFiles
  } else if (selectedFolderFiles && selectedFolderFiles.length > 0) {
    _selectedFiles = selectedFolderFiles
  }

  const accept = '*'

  let isCroppable = false

  const [updating_local, setUpdating_local] = useState()
  const [useAvatar, setAvatar] = useState(isCroppable)
  const [showPath, setShowPath] = useState()

  const uploadReady = useMemo(() => {
    const hasFiles = !_.isEmpty(allFiles)
    const hasSelected = !_.isEmpty(_selectedFiles)
    return hasFiles || hasSelected
  }, [allFiles, _selectedFiles])


  /** Starts the process of uploading the file to Firebase Storage using the upload_handlers */
  const handleImageUpload = async () => {

    console.log('fot', fot, uploadPath)
    console.log('_fileManagmentOpts', _fileManagmentOpts)
    console.log('files_info', files_info)
    // upload_handlers.handleStartUpdate() 
    const cb = () => {
      setUpdating_local(false)
      handleCancel()
    }
    setUpdating_local(true)

    switch (fot) {
      // case gEnums.fileOptionTypes.clientProfile:
      //   handleUpload_profiles({ fileList, useEmail: true, uploadPath })
      default:
        if (useAvatar) {
          const canvasScaled = avatarEditor.getImageScaledToCanvas()
          handleUpload_manual({ fileManagmentOpts: _fileManagmentOpts, uploadPath, fileOptionType: fot, storageType: _storageType, storageLocationType: _storageLocationType, useAvatar, canvas: canvasScaled, formData: currentPageData, currentPageData, manifestFiles, callback: cb, })
        } else {
          if (allFiles) {
            handleUpload_manual({ fileManagmentOpts: _fileManagmentOpts, uploadPath, appImage: _appImage, fileOptionType: fot, storageType: _storageType, storageLocationType: _storageLocationType, formData: currentPageData, currentPageData, manifestFiles, callback: cb })
          } else {
            handleUpload_manual({ fileManagmentOpts: _fileManagmentOpts, uploadPath, appImage: _appImage, fileOptionType: fot, storageType: _storageType, storageLocationType: _storageLocationType, formData: currentPageData, currentPageData, manifestFiles, callback: cb })
          }
        }
    }
  }

  const handleCloseUploader = () => {
    if (handleCancel) {
      handleCancel && handleCancel()
    } else {
      switch (storageLocationType) {
        case gEnums.storageLocationTypes.profileGallery:
          break;
        default:
          handleShow_appDashboard && handleShow_appDashboard()
        // nothing 
      }
    }
  }

  const handleImageDecline = () => {
    setShowPath()
    upload_handlers.handleDecline()
  }

  const handleOpenStorage = () => {
    switch (uivi) {
      case 'attendees':
      case 'speakers':
      case 'staff':
        openExternal.db(pathViews, true, ['profiles', email], true)
        break;
      default:
        openExternal.db(pathViews, true)
    }
  }

  const btnProps = { inverted: useDarkMode }

  const gi = (key, iconName, onClick, clickOptions, opts, corner) => <GenericIcon giProps={{ key, iconName, onClick, clickOptions, opts, corner }} />

  const killIcon = () => gi('icn-kill', appIconTypes.arrowLeft, fileViewer_handlers.handleShowUpload, null, { ...btnProps, fl: true })
  const backIcon = () => gi('icn-back', appIconTypes.arrowLeft, dataModify_handlers.handleCloseImageUploader, null, { ...btnProps, fl: true })

  const ddOptions = () => {
    const btns = []
    btns.push({ oc: handleOpenStorage, caption: 'Open Storage', icon: settingsIconTypes.openStorage, fl: true, color: 'orange' })
    return <DropdownOptionsMenu
      upward={true}
      menuButtons={btns}
      caption={'Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />
  }


  /** buttons that commit or reject the current image */
  const upload_buttons = () => <UiSaveButtons
    // cancel={{ oc: handleImageDecline }}
    dropdowns={ddOptions()}
    save={{ oc: handleImageUpload, caption: captions.ubc, disabled: !uploadReady, color: _allowUpload ? 'green' : 'teal' }}
  ></UiSaveButtons>

  const avatarButton = () => <Button icon basic color={useAvatar ? 'blue' : 'grey'} onClick={() => setAvatar(!useAvatar)} style={{ float: 'left' }} size={'small'}>
    <Icon name={'crop'} />
  </Button>

  /** Fragment containing an upload button AND the FileUploader */
  const uploadButtons = () => <React.Fragment>
    {upload_buttons()}
    {/* <UploadFileButton accept={accept} upload_handlers={upload_handlers} _storageRef={_storageRef} storageType={storageType} /> */}
  </React.Fragment>

  const selectButtons = () => (
    <div className={'uploader-header'}>
      {fileViewer_handlers && killIcon()}
      {dataModify_handlers && backIcon()}
      {/* {isCroppable && avatarButton()} */}
      {/* {!uploadReady && <UploadSelectButton accept={accept} upload_handlers={upload_handlers} _storageRef={_storageRef} storageType={storageType} />} */}
      {!showBulkUploader && uploadReady && uploadButtons()}
    </div>
  )

  /**
   * 
   * @returns BulkUploader OR SingleImageUploader
   */
  const contents = () => {
    if (showBulkUploader || selectedDataMode === frameworkLeftTypes.bulkImageUpload) {
      return <ItemStorageProvider showItemImage={true} viewItemKey={_viewItemKey}>
        <BulkUploader handleCancel={handleCloseUploader} />
      </ItemStorageProvider>
    } else {
      return <SingleImageUploader
        showPath={showPath}
        storageRef={storageRef}
        useAvatar={useAvatar}
        viewItemKey={_viewItemKey}
        storageType={_storageType}
        storageLocationType={_storageLocationType}
        inverted={inverted}
        item_state={item_state}
      />
    }
  }

  const wrapper = () => <Wrapper
    header={uploadCaption}
    content={contents()}
    footer={!showBulkUploader && uploadReady && selectButtons()}
    wrapperType={wrapperTypes.paddedHeader}
    updating={updating || updating_local}
    confirmation={confirmation}
    noMid={_noMid}
    css={{ header: 'wbbw', container: 'cnt-uploader app-dark-mode' }}
  />

  const fullPageUploader = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCloseUploader}
    topperCaption={captions.topper}
    topperCaption2={captions.topper2}
    fullMode={fullMode}
  />

  if (useFull) {
    return fullPageUploader()
  } else {
    return wrapper()
  }

}

const UploaderWithProvider = (props) => {
  return <UploadProvider {...props}>
    <Uploader {...props} />
  </UploadProvider>
}

export default UploaderWithProvider  
